import isBase64 from 'validator/lib/isBase64';
import { z } from 'zod';

import { decodeBase64, encodeBase64, hashSha256 } from 'vault-crypto';

import objectPassthrough from '../../objectPassthrough';

interface LoginAndroidApp {
  /* readonly */ appId: string;
  // deprecated, TODO remove when minClientVersion > TBD
  /* readonly */ signature: string;
  /* readonly */ signatureHash: string;
  /* readonly */ displayName: string;
}

const LoginAndroidApp = objectPassthrough({
  appId: z.string(),
  signature: z.string().refine(isBase64).default(''),
  // This used to be truncated to 20 bytes, but now it's the full sha256 hash
  signatureHash: z.string().refine(isBase64).optional(),
  displayName: z.string(),
  // This used to be set for most LoginAndroidApps, but it can get pretty big, particularly if
  // present in multiple history entries. We now drop the field in a transformation, to get rid of
  // that data
  iconDataUri: z.string().optional(),
})
  .transform(({ iconDataUri: _, ...app }) => app)
  .transform((o) => ({
    ...o,
    signatureHash:
      (
        // TODO enable recalc if signature is still available once android apps are somewhat deployed
        o.signatureHash === undefined // || (o.signatureHash.length === 28 && o.signature !== '')
      ) ?
        calcSignatureHash(o.signature)
      : o.signatureHash,
  }));

export function calcSignatureHash(signature: string) {
  return encodeBase64(hashSha256(decodeBase64(signature)));
}

interface InstalledAndroidApp {
  appId: string;
  signatureHash: string;
  displayName: string;
  iconDataUri?: string;
}

const InstalledAndroidApp = objectPassthrough({
  appId: z.string(),
  signatureHash: z.string().refine(isBase64),
  displayName: z.string(),
  iconDataUri: z.string().optional(),
});

export { LoginAndroidApp, InstalledAndroidApp };
